export default __webpack_public_path__ + "static/media/total_selling_pice.7e6bd147.svg";